import { Theme } from "../component/navigation/ThemeDropdown";

export default function TransmissionIcon({
    isSelected,
    theme,
}: {
    isSelected: boolean;
    theme: Theme;
}) {
    return (
        <div style={{ display: "inline-block", cursor: "pointer" }}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    transition: "fill 0.3s ease",
                }}
            >
                {/* Outer Circle */}
                <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37259 0 0 5.37258 0 12C0 18.6274 5.37259 24 12 24Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Top Arrow */}
                <path
                    d="M12.2103 8.8702L14.2042 10.4458H17.737C18.0332 10.4458 18.1676 10.1099 17.9447 9.9328L12.2073 5.4015C12.0882 5.30684 11.9111 5.30684 11.792 5.4015L6.05458 9.9328C5.83168 10.1099 5.96603 10.4458 6.26221 10.4458H9.79504L11.7889 8.8702C11.908 8.77554 12.0851 8.77554 12.2042 8.8702H12.2103Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Middle Arrow */}
                <path
                    d="M17.945 13.4015L14.2015 10.4457H9.79541L6.0519 13.4015C5.829 13.5786 5.96335 13.9144 6.25953 13.9144H9.87479L11.7862 12.403C11.9053 12.3083 12.0824 12.3083 12.2015 12.403L14.113 13.9144H17.7282C18.0244 13.9144 18.1588 13.5786 17.9359 13.4015H17.945Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Bottom Arrow */}
                <path
                    d="M6.05733 16.9374C5.83443 17.1145 5.96878 17.4504 6.26497 17.4504H17.7367C18.0329 17.4504 18.1673 17.1145 17.9444 16.9374L14.1214 13.9175H9.88023L6.05733 16.9374Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
            </svg>
        </div>
    );
}
